import WorkersModal from './WorkersModal';

export default WorkersModal;
